import e from"styled-components";const o=e.div`
	background: url(${({imageUrl:e})=>e});
	background-size: cover;
	background-position: ${({position:e})=>e?`${e.x}% ${e.y}%`:"center"};
	border-radius: ${({borderRadius:e})=>`${e}px`};
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	gap: 90px;
	height: 262px;
	padding: 12px 14px;
	position: relative;
	overflow: hidden;

	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 50%;
		background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
		pointer-events: none;
	}
`,t=e.div`
	background: none;
	border: none;
	background-color: ${({backgroundColor:e})=>e};
	color: ${({color:e})=>e};
	font-size: 18px;
	padding: 12px 18px;
	border-radius: 9999px;
	align-self: center;
	width: fit-content;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,n=e.div`
	display: flex;
	align-items: center;
	justify-content: ${({hasLinkText:e})=>e?"space-between":"end"};
	z-index: 10;
	height: 34px;
`,i=e.span`
	color: rgba(255, 255, 255, 0.6);
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,r=e.div`
	background-color: rgba(0, 0, 0, 0.6);
	padding: 7px;
	border-radius: 9999px;
	line-height: 0;
`;export{r as CardArrow,t as CardButton,o as CardContainer,n as CardFooter,i as CardLink};
